import { find } from '../helpers';

const element = find('[data-video-stream]')

if (element) {
    import('./index')
}
